module.exports = __webpack_public_path__ + "static/media/missing-letters.7101bbf0.png";